import React, { useState } from 'react';
import { NavItem } from 'reactstrap';
import { NavLink as RouterNavLink, useLocation } from 'react-router-dom';
import * as AntdIcons from '@ant-design/icons';

const SidebarNavItem = ({ to, iconClass, icon, label, badge, isCollapsed, disabled = false, onClick, onNavigate, excludePaths = [] }) => {
    const location = useLocation();
    // excludePaths: child routes that have their own nav item (e.g. /decisions/chat under
    // /decisions) - without this both items light up at once.
    const excluded = excludePaths.some(path => location.pathname === path || location.pathname.startsWith(`${path}/`));
    const isActive = !excluded && (to === '/'
        ? location.pathname === '/'
        : location.pathname === to || location.pathname.startsWith(`${to}/`));
    const [isHovered, setIsHovered] = useState(false);

    const baseStyle = {
        color: '#FFFFFF',
        textDecoration: 'none',
        padding: isCollapsed ? '0.5rem' : '0.5rem 1rem',
        margin: isCollapsed ? '0 auto' : '0',
        display: 'flex',
        alignItems: 'center',
        justifyContent: isCollapsed ? 'center' : 'flex-start',
        borderRadius: '8px', // Rounded box
        width: isCollapsed ? '40px' : '100%',
        height: '40px',
        overflow: 'hidden',
        backgroundColor: disabled ? 'transparent' : (isActive ? '#FF670E' : (isHovered ? '#8a370f' : 'transparent')),
        transition: 'all 0.3s ease',
        cursor: 'pointer',
        opacity: 1,
        border: 'none',
        outline: 'none',
        font: 'inherit',
        textAlign: 'left'
    };

    // Render icon - support both Font Awesome classes and Ant Design icon components
    const renderIcon = () => {
        if (icon) {
            // It's an Ant Design icon component
            return React.createElement(icon, {
                style: { fontSize: '1rem', marginRight: isCollapsed ? 0 : '0.5rem' }
            });
        } else if (iconClass) {
            // It's a Font Awesome class
            return <i className={`${iconClass} me-2`} />;
        }
        return null;
    };

    return (
        <NavItem>
            {disabled ? (
                <button
                    type="button"
                    style={baseStyle}
                    title={label}
                    aria-disabled="true"
                    onClick={onClick}
                    onMouseEnter={() => setIsHovered(true)}
                    onMouseLeave={() => setIsHovered(false)}
                >
                    {renderIcon()}
                    {!isCollapsed && (
                        <span className="sidebar-nav-label">
                            <span className="sidebar-nav-label-text">{label}</span>
                            {badge && <span className="sidebar-nav-badge">{badge}</span>}
                        </span>
                    )}
                </button>
            ) : (
                <RouterNavLink
                    to={to}
                    className="sidebar-link"
                    style={baseStyle}
                    title={label}
                    onClick={onNavigate}
                    onMouseEnter={() => setIsHovered(true)}
                    onMouseLeave={() => setIsHovered(false)}
                >
                    {renderIcon()}
                    {!isCollapsed && (
                        <span className="sidebar-nav-label">
                            <span className="sidebar-nav-label-text">{label}</span>
                            {badge && <span className="sidebar-nav-badge">{badge}</span>}
                        </span>
                    )}
                </RouterNavLink>
            )}
        </NavItem>
    );
};

export default SidebarNavItem;
